<template>
  <div class="cooperation">
    <div class="main-container">
      <div class="top-container"></div>
      <div class="main">
        <div class="title">Cooperation Services</div>
        <div class="desc">
          Please fill out the form and leave your contact information, we will communicate with you about cooperation details as soon as possible
        </div>
        <div class="form">
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-title required">Name:</div>
              <input placeholder="Please enter your name" v-model="form.name" />
            </div>
            <div class="form-item">
              <div class="form-item-title required">Contact Phone:</div>
              <input placeholder="Please enter your contact phone" v-model="form.phone" />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-title required">Industry:</div>
              <input placeholder="Please enter your industry" v-model="form.industry" />
            </div>
            <div class="form-item">
              <div class="form-item-title required">Main Business:</div>
              <input
                placeholder="Please enter your main business"
                v-model="form.main_business"
              />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
                <div class="form-item-title required">Requirements:</div>
                <textarea placeholder="Please enter your requirements" v-model="form.introduction"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <button @click="onSubmit">Submit</button>
      </div>
      <div class="desc">
        <p>For more requirements, you can contact Yichuang Community Online service</p>
        <p>Working Hours: 9:00-18:00 (Weekdays)</p>
      </div>
    </div>
  </div>
</template>
<script>
import {SubmitCooperation} from '@/api/social';
export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        industry: "",
        main_business: "",
        introduction: "",
      },
    };
  },
  mounted() {},
  methods: {
    async onSubmit(){
        try{
            const {code,msg} = await SubmitCooperation(this.form);
            if(code>0) this.$layer.msg(msg);
            this.$layer.msg('Submitted successfully, please wait for our contact');
            this.form = {
              name: "",
              phone: "",
              industry: "",
              main_business: "",
              introduction: "",
            }
            this.$router.push({name:'SubmitResult'});
        }catch(e){
            if(e.code > 0){
                this.$layer.msg(msg);
            }
        }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./businesscooperation.scss";
</style>
